[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 19,
                "key": "iVCmWxYKttvGSyXZSg87w"
            },
            {
                "x": 17,
                "y": 19,
                "key": "2r-yapxKAvT48-5Ustp6c"
            },
            {
                "x": 17,
                "y": 23,
                "key": "kDpdtrwyONiIm8ueOqe6b"
            },
            {
                "x": 12,
                "y": 23,
                "key": "eG9gBlnfAUmEyEtSzKxmd"
            }
        ]
    },
    {
        "key": "2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 12,
                "y": 15,
                "key": "3x16uRR1rkjTyrpxjzTa9"
            },
            {
                "x": 18,
                "y": 15,
                "key": "Q9RasXA54xYer94JrFTwn"
            },
            {
                "x": 18,
                "y": 19,
                "key": "6c_Tz7vWWHgbxz8mmycCV"
            },
            {
                "x": 12,
                "y": 19,
                "key": "J-0kGHR-30GcSgSckkFk4"
            }
        ]
    },
    {
        "key": "3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 11,
                "y": 11,
                "key": "IvFPs_2XR5a59MuaEWvpJ"
            },
            {
                "x": 18,
                "y": 11,
                "key": "KspUAjGTyNGob4WuwIHoD"
            },
            {
                "x": 18,
                "y": 15,
                "key": "2WRdHIAObyc3HH_d6wb2b"
            },
            {
                "x": 11,
                "y": 15,
                "key": "9r-wg0unPlGvlaTsUKcd8"
            }
        ]
    },
    {
        "key": "4",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 11,
                "y": 7,
                "key": "obtyVSnVcgDS8AIKogV1X"
            },
            {
                "x": 19,
                "y": 7,
                "key": "hoLvYG7GP-uHbb91jmyN1"
            },
            {
                "x": 19,
                "y": 11,
                "key": "nh3sVn1WwlmlCN8qxT8Wr"
            },
            {
                "x": 11,
                "y": 11,
                "key": "52jXorlp6MDXgpQBTq0Ya"
            }
        ]
    }
]